import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import InstagramIcon from "@mui/icons-material/Instagram";
import "../App.css";
import "../componentStyling/SlideBar.css";

export default function Slidebar() {
  const [select, setSelect] = useState(0);
  const [isVisible] = useState(true);



  const navItems = [
    { label: "Home", href: "/#", index: 0 },
    { label: "About Me", href: "#about", index: 1 },
    { label: "Resume", href: "#resume", index: 2 },
    { label: "My Projects", href: "#projects", index: 3 },
    { label: "Contact", href: "#contact", index: 4 }
  ];

  const socialLinks = [
    { icon: GitHubIcon, url: "https://github.com/khmorad", color: "hover:text-gray-400" },
    { icon: LinkedInIcon, url: "https://www.linkedin.com/in/kmoradpour/", color: "hover:text-blue-400" },
    { icon: InstagramIcon, url: "", color: "hover:text-pink-400" }
  ];

  const sidebarVariants = {
    hidden: { x: -300, opacity: 0 },
    visible: { 
      x: 0, 
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const itemVariants = {
    hidden: { x: -50, opacity: 0 },
    visible: (i) => ({
      x: 0,
      opacity: 1,
      transition: { delay: i * 0.1, duration: 0.5 }
    })
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="slidebar-container glass-dark backdrop-blur-xl"
          variants={sidebarVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
        >
          <div className="nav flex text-white text-lg mt-10 flex-col align-middle justify-center text-center w-full gap-6 overflow-hidden px-6">
            {/* Profile Section */}
            <motion.div
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="mb-8"
            >
              <motion.div
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.3 }}
              >
                <img
                  src={require("../assets/images/MyImage.webp")}
                  alt="Khashayar Moradpour"
                  className="rounded-full border-4 border-gradient-to-r from-blue-500 to-purple-500 cursor-pointer mx-auto max-w-[180px] shadow-2xl"
                />
              </motion.div>
              <motion.h3 
                className="text-white name py-4 font-semibold text-lg"
                whileHover={{ scale: 1.02 }}
              >
                Khashayar (Yar)
                <br />
                <span className="gradient-text">Moradpour</span>
              </motion.h3>
            </motion.div>

            {/* Navigation Items */}
<div className="space-y-4">
  {navItems.map((item, index) => (
    <motion.div
      key={index}
      custom={index}
      variants={itemVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.a
        onClick={() => setSelect(item.index)}
        href={item.href}
        className={`cursor-pointer font-medium transition-all duration-300 py-2 px-4 relative overflow-visible ${
          select === item.index 
            ? "text-blue-400" 
            : "hover:text-blue-400"
        }`}
        whileHover={{ 
          scale: 1.05,
          x: 5,
          transition: { duration: 0.2 }
        }}
        whileTap={{ scale: 0.95 }}
      >
        <span className="relative z-10">
          {item.label}
          {/* Animated underline */}
          <motion.div
            className="absolute bottom-0 left-0 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full"
            initial={{ width: 0 }}
            animate={{ width: select === item.index ? '100%' : '0%' }}
            transition={{ duration: 0.3 }}
          />
        </span>
      </motion.a>
    </motion.div>
  ))}
</div>


            {/* Social Links */}
            <motion.div
              className="flex flex-row gap-4 w-fit mx-auto pt-8 mt-auto"
              initial={{ y: 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              {socialLinks.map((social, index) => {
                const IconComponent = social.icon;
                return (
                  <motion.div
                    key={index}
                    whileHover={{ 
                      scale: 1.2, 
                      y: -3,
                      transition: { duration: 0.2 }
                    }}
                    whileTap={{ scale: 0.9 }}
                  >
                    <button
                      onClick={() => social.url && window.open(social.url, "_blank")}
                      className={`glass w-12 h-12 rounded-xl flex items-center justify-center text-white ${social.color} transition-all duration-300 hover:shadow-lg hover:shadow-blue-500/20`}
                    >
                      <IconComponent className="text-lg" />
                    </button>
                  </motion.div>
                );
              })}
            </motion.div>

            {/* Status Indicator */}
            <motion.div
              className="flex items-center justify-center gap-2 mt-4 text-sm text-gray-400"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1 }}
            >
              <motion.div
                className="w-2 h-2 bg-green-500 rounded-full"
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
              />
              <span>Available for work</span>
            </motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
